<template>
  <div class="py-5">
    <v-card-title>
      Administrer les offres
    </v-card-title>
    <div class="d-flex flex-row flex-wrap mt-6 justify-center">
      <div
        v-for="(offre, index) in offresAbonnement"
        :key="index"
        class="mx-5 pb-5"
      >
        <OffreAbonnement :offre="offre" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import OffreAbonnement from '@/views/admin/offre-abonnement/components/offre-abonnement.vue'

export default {
  name: 'OffreAbonnementAdmin',
  components: {OffreAbonnement},
  data () {
    return {
      loading: false,
      erreur: false
    }
  },
  computed: {
    ...mapGetters({
      offresAbonnement: 'offreAbonnement/offresAbonnement'
    })
  },

  created () {
    this.loadOffresAbonnement()
  },

  methods: {
    ...mapActions({
      getAllOffreAbonnement: 'offreAbonnement/getAllOffreAbonnement'
    }),

    loadOffresAbonnement () {
      this.loading = true
      this.erreur = false

      this.getAllOffreAbonnement()
        .catch(() => this.erreur = true)
        .finally(() => this.loading = false)
    }
  }
}
</script>
